import PaymentStatusTitleContainer from './PaymentStatusTitleContainer';

export default PaymentStatusTitleContainer;
